// Onderzoek & onderbouwing — gecontroleerd tegen de oorspronkelijke bronnen.

export const ONDERZOEKEN = [
  {
    k: "cbs",
    n: "01",
    org: "CBS",
    kop: "Het aanbod is omvangrijk",
    cijfer: "263.100",
    cijferLabel: "lopende re-integratie- en participatievoorzieningen, eind december 2025",
    extra: "voor 186.070 personen",
    feit: "Eind december 2025 liepen er 263.100 re-integratie- en participatievoorzieningen, voor 186.070 personen.",
    interpretatie: "Nederland beschikt over een groot aantal voorzieningen. Er wordt al veel gedaan aan activering, begeleiding en participatie.",
    nuance: "Eén persoon kan meer dan één voorziening hebben. Het aantal zegt niets over de passendheid of het effect van die voorzieningen.",
    kaart: "Nederland beschikt al over een omvangrijk ondersteuningsaanbod.",
    bronnen: ["cbs1", "cbs2"],
  },
  {
    k: "scp",
    n: "02",
    org: "SCP",
    kop: "Het ondersteuningsgat",
    cijfer: "Geen ondersteuning",
    cijferLabel: "voor veel mensen die langdurig afhankelijk zijn van de bijstand",
    feit: "Het Sociaal en Cultureel Planbureau beschrijft dat veel mensen die langdurig afhankelijk zijn van de bijstand geen ondersteuning meer ontvangen vanuit het sociaal domein.",
    interpretatie: "Voor een aanzienlijke groep is betaald werk nog geen realistisch perspectief. Passende ondersteuning kan zich ook richten op stabiliteit, maatschappelijke participatie en kwaliteit van leven.",
    nuance: "Het SCP beschrijft landelijke patronen. Per gemeente kan de situatie verschillen.",
    kaart: "Niet iedereen wordt passend bereikt.",
    bronnen: ["scp1", "scp2"],
  },
  {
    k: "amsterdam",
    n: "03",
    org: "Gemeente Amsterdam",
    kop: "De aansluiting in de praktijk",
    cijfer: "Ruim 7 op 10",
    cijferLabel: "nieuwe instromers zonder geregistreerd werkinstrument in de onderzochte tien maanden",
    extra: "1.879 van 6.910 met ten minste één instrument",
    feit: "Onderzoekers brachten 87 werkinstrumenten in kaart, verdeeld over 16 groepen. Van de 6.910 nieuwe bijstandsontvangers in de onderzochte instroomperiode was bij 1.879 ten minste één werkinstrument ingezet of geregistreerd.",
    interpretatie: "Beschikbaarheid van instrumenten betekent niet automatisch dat deze worden ingezet.",
    nuance: "Het gaat om instromers tussen begin 2022 en voorjaar 2023. Het onderzoek gaat over nieuwe instromers, niet specifiek over langdurig bijstandsgerechtigden. Geen geregistreerd instrument betekent niet automatisch dat er geen persoonlijk contact of andere begeleiding is geweest.",
    kaart: "Beschikbaarheid van instrumenten betekent niet automatisch dat deze worden ingezet.",
    bronnen: ["ams"],
  },
  {
    k: "ruig",
    n: "04",
    org: "De Ruig (2021)",
    kop: "Persoonlijke begeleiding",
    cijfer: "Kleine positieve effecten",
    cijferLabel: "bij intensieve persoonlijke begeleiding in pilots in Tilburg, Leiden en Helmond",
    feit: "Bij intensieve persoonlijke begeleiding werden kleine positieve effecten waargenomen op onder andere eigen regie, ervaren belemmeringen en stappen richting persoonlijke doelen.",
    interpretatie: "Dit ondersteunt de relevantie van persoonlijke begeleiding als onderzoeksrichting.",
    nuance: "Dit onderzoek gaat over andere interventies. Het bewijst niet dat de LevelLeven-methodiek effectief is.",
    bronnen: ["ruig"],
  },
  {
    k: "divosa",
    n: "05",
    org: "Divosa",
    kop: "Langdurige bijstand en uitstroom",
    cijfer: "11,5% → 7,9%",
    cijferLabel: "jaarlijkse uitstroom naar werk als aandeel van het gemiddelde bijstandsbestand (2021 → 2024 en 2025)",
    extra: "25% van de uitstromers na 5+ jaar bijstand vond een betaalde baan",
    feit: "De jaarlijkse uitstroom naar werk daalde van 11,5% in 2021 naar 7,9% in 2024 en 2025. Ook na meer dan vijf jaar bijstand vond 25% van de mensen die uit de bijstand stroomden een betaalde baan.",
    interpretatie: "Ook na lange tijd in de bijstand blijft een stap naar werk mogelijk, maar voor velen niet vanzelfsprekend.",
    nuance: "Het cijfer van 25% gaat alleen over de mensen die uitstroomden, niet over alle langdurig bijstandsgerechtigden. De twee percentages meten iets anders en zijn niet met elkaar te vergelijken.",
    bronnen: ["divosa"],
  },
];

export const BRONNEN = {
  cbs1: {
    apa: "Centraal Bureau voor de Statistiek. (2026). Re-integratie-/participatievoorzieningen; type, status voorziening en regio [Dataset 85588NED]. StatLine.",
    url: "https://www.cbs.nl/nl-nl/cijfers/detail/85588NED",
  },
  cbs2: {
    apa: "Centraal Bureau voor de Statistiek. (2026). Personen met re-integratie-/participatievoorzieningen [Dataset 85589NED]. StatLine.",
    url: "https://www.cbs.nl/nl-nl/cijfers/detail/85589NED",
  },
  scp1: {
    apa: "Sociaal en Cultureel Planbureau. (2023, 9 juni). Participatiewet heeft te grote focus op betaald werk [Nieuwsbericht].",
    url: "https://www.scp.nl/actueel/nieuws/2023/06/09/participatiewet-heeft-te-grote-focus-op-betaald-werk",
  },
  scp2: {
    apa: "Sociaal en Cultureel Planbureau. (2024). Vertrouwen in de bijstand.",
    url: "https://www.scp.nl/documenten/2024/11/05/vertrouwen-in-de-bijstand",
  },
  ams: {
    apa: "Gemeente Amsterdam, Onderzoek en Statistiek. (2026). Instrumententrajecten van recente bijstand-instromers.",
    url: "https://onderzoek.amsterdam.nl/publicatie/instrumententrajecten-van-recente-bijstand-instromers",
  },
  ruig: {
    apa: "De Ruig, L. (2021). Persoonlijke begeleiding in de Participatiewet: Drie veelbelovende gemeentelijke pilots. Tijdschrift voor Arbeidsvraagstukken, 37(3).",
    url: "https://doi.org/10.5117/TVA2021.3.004.RUIG",
  },
  divosa: {
    apa: "Divosa. (2026, 27 oktober). Analyse uitstroom 2021–2025: Ook na vijf jaar bijstand blijft kans op werk reëel.",
    url: "https://www.divosa.nl/nieuws/analyse-uitstroom-2021-2025-ook-na-vijf-jaar-bijstand-blijft-kans-op-werk-reeel",
  },
};

export const KETEN = [
  "Veel voorzieningen beschikbaar",
  "Niet iedereen passend bereikt",
  "Voor sommigen is werk nog niet de eerste stap",
  "Behoefte aan passende ondersteuning",
  "LevelLeven onderzoekt een aanvullende ontwikkelroute",
];

export const PIJLERS = [
  { n: "01", t: "De doelgroep", d: "Inwoners die langdurig stilstaan, meerdere belemmeringen ervaren en voor wie een directe stap naar werk nog niet passend is.", c: "#F0B98D" },
  { n: "02", t: "De volgorde", d: "Eerst zelfinzicht, vertrouwen, bewustwording en eigen regie. Daarna een passende richting naar participatie, scholing of werk.", c: "#97B79D" },
  { n: "03", t: "De intensiteit", d: "Een twaalfweekse ontwikkelomgeving met bij voorkeur 20–22 deelnemers, maximaal 24 waar verantwoord, twee trainers, groepsleren en persoonlijke aandacht.", c: "#E06B3F" },
  { n: "04", t: "De methodiek", d: "Een samenhangend programma rond bewustwording, communicatie, gedrag, overtuigingen, vaardigheden, veerkracht en toekomstperspectief.", c: "#78A85A" },
  { n: "05", t: "De resultaten", d: "Ontwikkeling zichtbaar maken met start-, tussen- en eindmetingen. Niet alleen kijken naar werk, maar ook naar eigen regie, gedrag, vaardigheden en passende vervolgstappen.", c: "#D4A94A" },
  { n: "06", t: "De aansluiting", d: "LevelLeven wil een voorbereidende en aanvullende ontwikkelfase vormen, in samenwerking met bestaande gemeentelijke voorzieningen en uitvoeringspartners.", c: "#1F5132" },
];

export const PIJLERS_KERN =
  "Eén samenhangende ontwikkelmethodiek. Van langdurige stilstand naar zichtbare ontwikkeling en een passende volgende stap.";

export const START_FEITEN = [
  { l: "Duur", v: "12 weken" },
  { l: "Groep", v: "20–22", s: "max. 24 waar verantwoord" },
  { l: "Begeleiding", v: "2 trainers", s: "per groep" },
  { l: "Indicatief", v: "± €5.000", s: "per deelnemer" },
];

export const MEETMOMENTEN = [
  { t: "Startmeting", d: "Bij aanvang. Waar staat iemand nu, in eigen woorden en met een vragenlijst." },
  { t: "Tussenmeting", d: "Een of meer momenten tijdens START. Wat komt in beweging, wat blijft lastig?" },
  { t: "Eindmeting", d: "Aan het einde van week 12. Wat lukt nu wat aan het begin nog niet lukte?" },
  { t: "Vervolgmeting", d: "Waar afgesproken, enige tijd na START. Houdt de ontwikkeling stand?" },
];

export const ONTWIKKELGEBIEDEN = ["Zelfregie", "Dagstructuur", "Sociale vaardigheden", "Vertrouwen", "Toekomstperspectief"];
